import Header from '../Header';

interface PropTypes {
  children: React.ReactNode;
}

function Wrapper({ children }: PropTypes) {
  return (
    <div className="flex flex-col w-full min-w-screen max-w-screen h-full overflow-hidden">
      <Header />
      <div
        className="flex flex-col w-screen h-full pt-[120px] md:pt-[64px]"
        id="wrapper-body"
      >
        {children}
      </div>
    </div>
  );
}

export default Wrapper;
